
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";

createRoot(document.getElementById("root")!).render(
  // Opt in to React Router v7 behaviour now (silences the future-flag
  // warnings). v7_relativeSplatPath only changes relative links rendered
  // directly by a splat ("*") route; ours are absolute or search-only
  // ("?category=...") inside non-splat routes, so nothing changes.
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <App />
  </BrowserRouter>
);
  
